var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifierMagnifyingGlassSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M633.8176 637.44l60.6464-60.6336 108.608 108.608-60.6464 60.6336z",
    fill: "#C1BDA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M742.4 764.16l-126.72-126.72 79.36-79.36 126.72 126.72-79.36 79.36z m-90.88-126.72l90.88 90.88 42.24-42.24-90.88-90.88-42.24 42.24z",
    fill: "#231C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M942.08 785.92c29.44 29.44-1.28 55.04-28.16 81.92-26.88 26.88-38.4 43.52-67.84 14.08l-111.36-108.8c-29.44-29.44-30.72-74.24-3.84-99.84 26.88-26.88 71.68-24.32 99.84 3.84l111.36 108.8z",
    fill: "#486068"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M872.96 910.08c-11.52 0-23.04-6.4-35.84-19.2l-111.36-108.8c-16.64-16.64-25.6-37.12-26.88-60.16-1.28-23.04 6.4-43.52 23.04-58.88S759.04 640 780.8 640c21.76 1.28 43.52 10.24 60.16 26.88l111.36 108.8c10.24 10.24 15.36 21.76 15.36 33.28 0 23.04-19.2 42.24-38.4 61.44l-10.24 10.24c-16.64 16.64-29.44 29.44-46.08 29.44z m-96-243.2c-14.08 0-26.88 5.12-37.12 15.36-10.24 10.24-15.36 24.32-15.36 39.68 1.28 15.36 7.68 30.72 19.2 42.24l111.36 108.8c7.68 7.68 14.08 11.52 17.92 11.52 6.4 0 15.36-8.96 26.88-20.48l10.24-10.24c15.36-15.36 30.72-30.72 30.72-43.52 0-5.12-2.56-10.24-7.68-15.36l-111.36-108.8c-11.52-11.52-26.88-19.2-42.24-19.2h-2.56z",
    fill: "#231C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.4 410.88m-294.4 0a294.4 294.4 0 1 0 588.8 0 294.4 294.4 0 1 0-588.8 0Z",
    fill: "#486068"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M454.4 718.08c-168.96 0-307.2-138.24-307.2-307.2s138.24-307.2 307.2-307.2 307.2 138.24 307.2 307.2-138.24 307.2-307.2 307.2z m0-588.8c-154.88 0-281.6 126.72-281.6 281.6s126.72 281.6 281.6 281.6 281.6-126.72 281.6-281.6-126.72-281.6-281.6-281.6z",
    fill: "#231C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M454.4 410.88m-217.6 0a217.6 217.6 0 1 0 435.2 0 217.6 217.6 0 1 0-435.2 0Z",
    fill: "#F2E5CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M454.4 641.28c-126.72 0-230.4-103.68-230.4-229.12s103.68-230.4 230.4-230.4 229.12 103.68 229.12 230.4-102.4 229.12-229.12 229.12z m0-433.92c-112.64 0-204.8 92.16-204.8 204.8s92.16 203.52 204.8 203.52 203.52-92.16 203.52-203.52-90.88-204.8-203.52-204.8z",
    fill: "#231C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierMagnifyingGlassSvgrepoCom);
export default __webpack_public_path__ + "static/media/magnifier-magnifying-glass-svgrepo-com.88ef8ab64c4c7afa296b537fdd2c8da8.svg";
export { ForwardRef as ReactComponent };